import CommonLabel from "./CommonLabel";

export default CommonLabel;
